import { WindowCommunication as WindowCommunicationComponent, WindowCommunicationLink } from "./WindowCommunication";

export const WindowCommunication = Object.assign(WindowCommunicationComponent, {
  Link: WindowCommunicationLink
});

export { useWindowCommunicationConsumer } from "./hooks"